/*
  Keeps the WhatsApp float button (snippets/whatsapp-float.liquid) clear of
  the footer instead of overlapping it. position: fixed pins the button to
  the viewport corner regardless of scroll position, so once the footer
  scrolls into view the button would otherwise sit on top of it (this is
  what happened with the previous Whapi app embed). Rather than a fixed
  extra offset (which is either too small on short pages or wastes space on
  tall ones), this measures how much of <footer> is actually on screen and
  pushes the button up by exactly that amount via a CSS custom property.
*/
(function () {
  var button = document.querySelector('.whatsapp-float');
  var footer = document.querySelector('footer');

  if (!button || !footer || !('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var offset = entry.isIntersecting ? entry.intersectionRect.height : 0;
        button.style.setProperty('--whatsapp-float-footer-offset', offset + 'px');
      });
    },
    { threshold: [0, 0.01, 0.5, 1] }
  );

  observer.observe(footer);
})();
